<form [formGroup]="bankRelationshipForm()">
  <h2>Välj sparkonto</h2>
  <div class="account-holder"
       [class.small-screen]="orientationService.isSmallScreen()"
       tabindex="0">

    <button class="account-option"
            [class.small-screen]="orientationService.isSmallScreen()"
            tabindex="0"
            (click)="toggleAccount('openSavingsAccount')"
            (keydown.enter)="toggleAccount('openSavingsAccount'); $event.preventDefault()"
            [class.selected]="bankRelationshipForm().get('openSavingsAccount')?.value"
            [attr.aria-label]="routeService.onHorseRoute() ? 'Välj Hästsparkonto utan bindningstid' : 'Välj sparkonto utan bindningstid med ' + savingsInterest + '% ränta'"
            [attr.aria-pressed]="bankRelationshipForm().get('openSavingsAccount')?.value">
      <div class="account-details">
        <div class="title">
          @if (routeService.onHorseRoute()) {
            Hästsparkonto
          } @else {
            Sparkonto
          }
        </div>
        <p>{{ savingsInterest }}% ränta</p>
        <p class="underline">Ingen bindningstid</p>

        @if (routeService.onHorseRoute()) {
          <p class="small-info">För dig med häst eller gård</p>
        }
      </div>
    </button>

    <button class="account-option"
            [class.small-screen]="orientationService.isSmallScreen()"
            tabindex="0"
            (click)="toggleAccount('openFixedRateAccount')"
            (keydown.enter)="toggleAccount('openFixedRateAccount'); $event.preventDefault()"
            [class.selected]="bankRelationshipForm().get('openFixedRateAccount')?.value"
            [attr.aria-label]="'Välj fasträntekonto med ' + minInterestRate + '% till ' + maxInterestRate + '% ränta och 3 månader till 5 år bindningstid'"
            [attr.aria-pressed]="bankRelationshipForm().get('openFixedRateAccount')?.value">
      <div class="account-details">
        <div class="title">Fasträntekonto</div>
        <p>{{ minInterestRate }}% - {{ maxInterestRate }}% ränta</p>
        <p class="underline">3 mån - 5 år bindningstid</p>
      </div>
    </button>
  </div>

  @if (routeService.onHorseRoute() && bankRelationshipForm().get('openSavingsAccount')?.value) {
    <div class="margin-bottom-medium confirmation-section">
      <mat-checkbox
        formControlName="hasHorseOrFarm"
        (keydown.enter)="bankRelationshipForm().patchValue({hasHorseOrFarm: !bankRelationshipForm().get('hasHorseOrFarm')?.value}); $event.preventDefault()"
        [attr.aria-required]="true"
        [attr.aria-invalid]="bankRelationshipForm().get('hasHorseOrFarm')?.invalid && bankRelationshipForm().get('hasHorseOrFarm')?.touched">
        Jag intygar att jag äger häst eller gård
      </mat-checkbox>

      @if (bankRelationshipForm().get('hasHorseOrFarm')?.invalid && bankRelationshipForm().get('hasHorseOrFarm')?.touched) {
        <div class="mat-error-container">
          <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
          <mat-error>Du måste intyga att du äger häst eller gård för att öppna
            detta konto
          </mat-error>
        </div>
      }
    </div>
  }

  @if (bankRelationshipForm().controls.openFixedRateAccount.value === true) {
    <div
      class="interest-holder"
      [class.small-screen]="orientationService.isSmallScreen()"
    >
      <p>Välj bindningstid och ränta ({{ interestDate }})</p>
      <mat-form-field
        [class.small-screen]="orientationService.isSmallScreen()"
      >
        <mat-label>Vänligen välj här</mat-label>
        <mat-select
          placeholder="Vänligen välj här"
          [errorStateMatcher]="customErrorStateMatcher"
          formControlName="interestRunningTime"
        >
          @for (option of interestRunningTimeOptions; track option) {
            <mat-option
              [value]="option.value">
              {{ option.label }} ({{ option.interestRate }}%)
            </mat-option>
          }
        </mat-select>

        @if (bankRelationshipForm().controls.interestRunningTime.errors && bankRelationshipForm().controls.interestRunningTime.touched) {
          <mat-icon matIconSuffix aria-hidden="true">
            priority_high
          </mat-icon>
        }

        <mat-error>Vänligen välj en bindningstid</mat-error>

      </mat-form-field>
    </div>

    <p>Vänligen ange det belopp du vill sätta in på fasträntekontot</p>
    <mat-form-field
      class="margin-bottom-medium"
      [class.small-screen]="orientationService.isSmallScreen()">
      <mat-label>Fastränteplacering belopp</mat-label>
      <input placeholder="Ange belopp"
             maxlength="16"
             formControlName="interestPlacementAmount"
             inputmode="numeric"
             spbFormatNumber
             matInput type="text"
             [errorStateMatcher]="customErrorStateMatcher">

      @if (bankRelationshipForm().controls.interestPlacementAmount.errors && bankRelationshipForm().controls.interestPlacementAmount.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      <mat-error
        [class.small-screen]="orientationService.isSmallScreen()"
      >Minsta belopp att överföra är 50 000 kronor. Högsta belopp att överföra
        är 10 miljoner kronor.
      </mat-error>

    </mat-form-field>
  }

  <div class="margin-bottom-medium"
       [class.selection-error]="showDuplicateError"
  >
    @if (bankRelationshipForm().controls.openFixedRateAccount.value === true) {
      <div [style.margin-bottom.px]="12">
        <mat-checkbox
          class="column"
          formControlName="existingSavingsAccount"
          [attr.aria-invalid]="showDuplicateError"
          (keydown.enter)="bankRelationshipForm().patchValue({existingSavingsAccount: !bankRelationshipForm().get('existingSavingsAccount')?.value}); $event.preventDefault()">
          {{ iHaveSpbAccount }}
        </mat-checkbox>
      </div>

      @if (bankRelationshipForm().controls.existingSavingsAccount.value === true) {
        <mat-form-field
          class="margin-bottom-medium"
          [class.small-screen]="orientationService.isSmallScreen()">

          <mat-label>Ange kontonummer (tio siffror)</mat-label>
          <input
            spbFormatAccount
            [skipClearing]="true"
            formControlName="existingSavingsAccountNumber"
            matInput type="text"
            [errorStateMatcher]="customErrorStateMatcher"
          >

          @if (bankRelationshipForm().controls.existingSavingsAccountNumber.invalid && bankRelationshipForm().controls.existingSavingsAccountNumber.touched) {
            <mat-icon matIconSuffix aria-hidden="true">
              priority_high
            </mat-icon>
          }

          <mat-error
            [class.small-screen]="orientationService.isSmallScreen()"
          >Vänligen ange ett konto i Sparbanken Syd. 10 siffror.
          </mat-error>

        </mat-form-field>
      }

      <mat-checkbox
        class="column"
        formControlName="openSavingsAccount"
        (change)="bankRelationshipForm().patchValue({openSavingsAccount: $event.checked})"
        (keydown.enter)="bankRelationshipForm().patchValue({openSavingsAccount: !bankRelationshipForm().get('openSavingsAccount')?.value}); $event.preventDefault()"
        [attr.aria-invalid]="showDuplicateError">
        {{ iWantNewAccount }}
      </mat-checkbox>
    }

    @if (showDuplicateError) {
      <div class="mat-error-container">
        <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
        <mat-error>Du kan endast välja ett alternativ.
          Vänligen välj antingen
          '{{ iHaveSpbAccount }}' eller '{{ iWantNewAccount }}'.
        </mat-error>
      </div>
    }
  </div>

  <div class="margin-bottom-medium">
    @if (routeService.onHorseRoute()) {
      <p class="select-title">Du kommer få ett erbjudande om ekonomisk
        rådgivning.</p>
    } @else {
      <p class="select-title">Utöver öppna ett sparkonto eller
        fastränteplacering vill jag även bli kontaktad för att bli informerad om
        bankens vardagstjänster och övriga produkter. </p>
      <div
        class="column"
        [class.selection-error]="bankRelationshipForm().get('wantToBeContacted')?.invalid && bankRelationshipForm().get('wantToBeContacted')?.touched || (validateContact && bankRelationshipForm().value.wantToBeContacted === null)">
        @for (option of yesOrNo; track $index) {
          <mat-checkbox
            [checked]="option.value === bankRelationshipForm().controls.wantToBeContacted.value"
            (change)="onCheckboxChange(option.value, 'wantToBeContacted', $event.checked)"
            (keydown.enter)="onCheckboxChange(option.value, 'wantToBeContacted', !(option.value === bankRelationshipForm().controls.wantToBeContacted.value)); $event.preventDefault()"
            [attr.aria-required]="true"
            [attr.aria-invalid]="bankRelationshipForm().get('wantToBeContacted')?.invalid && bankRelationshipForm().get('wantToBeContacted')?.touched"
            [attr.aria-describedby]="bankRelationshipForm().get('wantToBeContacted')?.invalid && bankRelationshipForm().get('wantToBeContacted')?.touched ? 'contact-error' : null"
            (keydown)="$index === yesOrNo.length - 1 ? (validateContact = true) : null"
          >
            {{ option.label }}
          </mat-checkbox>
        }

        @if (bankRelationshipForm().get('wantToBeContacted')?.invalid && bankRelationshipForm().get('wantToBeContacted')?.touched || (validateContact && bankRelationshipForm().value.wantToBeContacted === null)) {
          <div class="mat-error-container">
            <mat-icon aria-hidden="true" class="negative">priority_high
            </mat-icon>
            <mat-error id="contact-error">Vänligen gör ett val</mat-error>
          </div>
        }
      </div>
    }
  </div>
</form>